import { useImportContext } from '../import-context';
import styles from './styles.module.css';

/**
 * @param {object} props
 * @param {import('../../../data/types/types').MappedColumn} props.csvColumn
 * @returns {React.JSX.Element}
 */
export const CsvColumnValue = ({ csvColumn }) => {
  const { getCsvColumnFromDefinition } = useImportContext();

  return <div className={styles['column-value']}>{getCsvColumnFromDefinition(csvColumn?.csvColumn || '')}</div>;
};
